module.exports = __webpack_public_path__ + "static/media/photo_005.ae8b9f95.JPG";